import type {ForestMass} from '@/domain/entities/ForestMass';
import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';

export class UpdateForestMassUseCase {
  constructor(private readonly repository: ForestMassRepository) {}
  async execute(forestMass: ForestMass) {
    return this.repository.patch(forestMass);
  }
}
